import { Outlet } from "react-router-dom";

import Navbar from "../components/Navbar";

export default function Home() {
    return (
        <div>
            <Navbar />
            <div className="home-container">
                <Outlet />
            </div>
        </div>
    );
}
